var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{ref:"chart",attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.series,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }